import { render, staticRenderFns } from "./optionsItem.vue?vue&type=template&id=13dd3666&scoped=true"
import script from "./optionsItem.vue?vue&type=script&lang=js"
export * from "./optionsItem.vue?vue&type=script&lang=js"
import style0 from "./optionsItem.vue?vue&type=style&index=0&id=13dd3666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd3666",
  null
  
)

export default component.exports